"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const reactstrap_1 = require("reactstrap");
const react_i18next_1 = require("react-i18next");
const styles_1 = require("./styles");
const AppInfo = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { message, title = t('Informacao') } = props;
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const handleOnClickAppInfoButton = () => {
        setIsOpen(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reactstrap_1.Modal, { modalClassName: 'tema-pergamum', isOpen: isOpen, toggle: () => setIsOpen(!isOpen), size: 'lg', scrollable: true },
            react_1.default.createElement(reactstrap_1.ModalHeader, { style: { padding: "1rem 1rem 10px 1rem" }, className: "b-solid-bottom b-branco cortxt negrito", toggle: () => setIsOpen(!isOpen), 
                /* eslint-disable-next-line react/button-has-type */
                close: react_1.default.createElement("button", { className: "close s20 branco float-right mr-1 rad5", style: { fontWeight: 'normal' }, onClick: () => setIsOpen(false) },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "times", className: "fa-fw" })) },
                react_1.default.createElement("div", { className: "f700 branco s20 " }, title)),
            react_1.default.createElement(reactstrap_1.ModalBody, null,
                react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: message } })),
            react_1.default.createElement(reactstrap_1.ModalFooter, { className: "d-flex justify-content-center align-items-center position-relative" },
                react_1.default.createElement(reactstrap_1.Button, { onClick: () => setIsOpen(false), className: "danger", title: t('Ok') }, t('Ok')))),
        react_1.default.createElement(styles_1.AppInfoButton, { onClick: handleOnClickAppInfoButton },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faInfo }))));
};
exports.default = AppInfo;
